import { rem } from "polished";
import styled, { css } from "styled-components";

export const StyledPageContainer = styled.div<{
  $editing?: boolean;
  inEditPage?: boolean;
}>`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  ${(props) => {
    if (props.$editing || props.inEditPage) {
      return css`
        padding: ${rem(2)} 0;
        min-height: calc(100vh - var(--topBarHeight));
      `;
    }
  }};
`;

export const Main = styled.main`
  flex: 1 0 auto;
`;
